// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"9032": "e5afb1b9322338a6","9361": "b0c6d59bd26d5e02",}[chunkId] + ".bundle.css"
}